import { body, html } from "../helpers/elementsNodeList"
import ContactForm, { initContactForm } from "./contact-form"
import toggleBodyLock from "../helpers/toggleBodyLock"

function ModalInit() {
  const $modalsButtons = Array.from(
    document.querySelectorAll('[data-modal="contact"]'),
  )

  if ($modalsButtons.length < 1) return

  $modalsButtons.forEach((modalButton) =>
    modalButton.addEventListener("click", (event) => {
      event.preventDefault()
      OpenModal(modalButton)
    }),
  )

  function OpenModal(modalButton) {
    if (document.querySelector("#modal-contact")) {
      return
    }

    const sourceType = modalButton?.dataset.typeAction || ""
    const sourceName = modalButton?.dataset.nameField || ""

    const $modalWindow = document.createElement("div")
    $modalWindow.classList.add("modal-window")
    $modalWindow.id = "modal-contact"
    $modalWindow.insertAdjacentHTML(
      "beforeend",
      `
        <div class="modal-overlay" data-close-modal></div>
        ${ModalContent(ContactForm())}
      `,
    )

    body.insertAdjacentElement("beforeend", $modalWindow)
    fillOrderSource($modalWindow, sourceType, sourceName)
    initContactForm($modalWindow)

    requestAnimationFrame(() => {
      html.classList.add("open-modal")
    })

    const $closeModalButtons =
      $modalWindow.querySelectorAll("[data-close-modal]")
    $closeModalButtons.forEach((button) =>
      button.addEventListener("click", () => CloseModal($modalWindow)),
    )
    toggleBodyLock(true)
  }

  function CloseModal($modalWindow) {
    html.classList.remove("open-modal")
    html.classList.add("close-modal")
    toggleBodyLock(false)

    setTimeout(() => {
      html.classList.remove("close-modal")
      $modalWindow.remove()
    }, 300)
  }

  function fillOrderSource(container, sourceType, sourceName) {
    const form = container.querySelector("#contact-form")

    if (!form) {
      return
    }

    setHiddenValue(form, "source_type", sourceType)
    setHiddenValue(form, "source_name", sourceName)
  }

  function setHiddenValue(form, name, value) {
    let field = form.querySelector(`[name="${name}"]`)

    if (!field) {
      field = document.createElement("input")
      field.type = "hidden"
      field.name = name
      form.appendChild(field)
    }

    field.value = value || ""
  }
}

function ModalContent(content) {
  return `<div class="modal-content">
      <div class="modal-header">
      </div>
     ${content}
   </div>
 `
}

export { ModalInit }
